<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 24 24"
    :width="width"
  >
    <path d="M9.78197 1.95024C10.972 0.643539 13.028 0.643541 14.218 1.95024L15.2382 3.07047C15.4387 3.2906 15.7269 3.40996 16.0243 3.39606L17.5378 3.32532C19.3032 3.24281 20.7571 4.69666 20.6746 6.4621L20.6038 7.97562C20.5899 8.27303 20.7093 8.56117 20.9294 8.76164L22.0497 9.78185C23.3563 10.9719 23.3563 13.0279 22.0496 14.2179L20.9294 15.2381C20.7093 15.4386 20.5899 15.7267 20.6038 16.0242L20.6746 17.5377C20.7571 19.3031 19.3032 20.757 17.5378 20.6744L16.0243 20.6037C15.7269 20.5898 15.4387 20.7092 15.2382 20.9293L14.218 22.0495C13.028 23.3562 10.972 23.3562 9.78197 22.0495L8.76177 20.9293C8.56129 20.7092 8.27315 20.5898 7.97574 20.6037L6.46222 20.6744C4.69678 20.757 3.24294 19.3031 3.32544 17.5377L3.39618 16.0241C3.41008 15.7267 3.29073 15.4386 3.07059 15.2381L1.95036 14.2179C0.643661 13.0279 0.643663 10.9719 1.95036 9.78184L3.07059 8.76164C3.29073 8.56117 3.41008 8.27303 3.39618 7.97561L3.32544 6.4621C3.24294 4.69666 4.69678 3.24281 6.46222 3.32532L7.97574 3.39606C8.27315 3.40996 8.56129 3.2906 8.76177 3.07047L9.78197 1.95024ZM12.7394 3.29689C12.3427 2.86132 11.6573 2.86132 11.2607 3.29689L10.2405 4.41712C9.63903 5.07752 8.77461 5.43557 7.88237 5.39387L6.36886 5.32314C5.78037 5.29564 5.29576 5.78025 5.32326 6.36873L5.394 7.88225C5.4357 8.77449 5.07764 9.63891 4.41724 10.2403L3.29701 11.2605C2.86145 11.6572 2.86145 12.3426 3.29701 12.7392L4.41724 13.7594C5.07764 14.3609 5.4357 15.2253 5.394 16.1175L5.32326 17.631C5.29576 18.2195 5.78038 18.7041 6.36886 18.6766L7.88237 18.6059C8.77461 18.5642 9.63903 18.9222 10.2405 19.5826L11.2607 20.7029C11.6573 21.1384 12.3427 21.1384 12.7394 20.7029L13.7596 19.5826C14.361 18.9222 15.2254 18.5642 16.1176 18.6059L17.6312 18.6766C18.2196 18.7041 18.7043 18.2195 18.6767 17.631L18.606 16.1175C18.5643 15.2253 18.9224 14.3609 19.5828 13.7594L20.703 12.7392C21.1386 12.3426 21.1386 11.6572 20.703 11.2605L19.5828 10.2403C18.9224 9.63891 18.5643 8.77449 18.606 7.88225L18.6767 6.36873C18.7043 5.78025 18.2196 5.29564 17.6312 5.32314L16.1176 5.39387C15.2254 5.43557 14.361 5.07752 13.7596 4.41712L12.7394 3.29689ZM15.7071 9.29278C16.0976 9.6833 16.0976 10.3165 15.7071 10.707L11.7071 14.707C11.3166 15.0975 10.6834 15.0975 10.2929 14.707L8.2929 12.707C7.90237 12.3165 7.90237 11.6833 8.2929 11.2928C8.68342 10.9023 9.31659 10.9023 9.70711 11.2928L11 12.5857L14.2929 9.29278C14.6834 8.90225 15.3166 8.90225 15.7071 9.29278Z" fill="black"/>
  </svg>
</template>

<script>
export default {
  name: 'BadgeCheck',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
  },
};

</script>
